"use client"

import * as React from "react"
import { PanelRight } from "lucide-react"
import { TabsContent } from "@/components/ui/tabs"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"

export interface DockSettingsTabProps {
  dockPosition: "left" | "bottom" | "right"
  setDockPosition: (pos: "left" | "bottom" | "right") => void
  dockSize?: number
  setDockSize?: (size: number) => void
  dockAutoHide?: boolean
  setDockAutoHide?: (hide: boolean) => void
  dockAppIds?: string[]
  setDockAppIds?: React.Dispatch<React.SetStateAction<string[]>>
  installedApps?: any[]
}

export function DockSettingsTab({
  dockPosition,
  setDockPosition,
}: DockSettingsTabProps) {
  return (
    <TabsContent value="dock" className="outline-none space-y-6">
      <div>
        <h3 className="text-lg font-bold text-zinc-900 dark:text-white flex items-center gap-2">
          <PanelRight className="size-5 text-[#004EB1]" />
          Barra de Tarefas & Dock
        </h3>
        <p className="text-xs text-zinc-500 dark:text-zinc-400 mt-1 font-sans">
          Ajuste a posição e o comportamento da barra de aplicativos da área de trabalho.
        </p>
      </div>

      {/* Card: Posição da Dock */}
      <Card className="border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900">
        <CardHeader>
          <CardTitle className="text-sm font-bold text-zinc-800 dark:text-zinc-100 font-sans">
            Ajustes de Posição & Ícones da Dock
          </CardTitle>
        </CardHeader>
        <CardContent className="px-4 space-y-4 font-sans">
          <div className="space-y-2">
            <div className="flex gap-2">
              {(["left", "bottom", "right"] as const).map((pos) => (
                <Button
                  key={pos}
                  type="button"
                  variant={dockPosition === pos ? "default" : "outline"}
                  onClick={() => setDockPosition(pos)}
                  className="text-xs capitalize h-8 px-4 cursor-pointer"
                >
                  {pos === "left" ? "Esquerda" : pos === "bottom" ? "Inferior" : "Direita"}
                </Button>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  )
}
